import { Box, Button, Tooltip } from '@mui/material';

import Table, {
  DeleteButton,
  HeadCell,
  SwitchButton,
  UpdateButton,
  UserFormatter
} from 'src/content/common/Table';

import { RemoveRedEye } from '@mui/icons-material';
import { useState } from 'react';
import { Cotisation, UserInfos } from 'src/types';
import { deleteUserFunction, toggleUserStatus } from 'src/utils/api/user.api';
import { AutoCotisationModal } from '../cotisation/CotisationForm';
import { ShowUserModal, UpdateMemberCard, UpdateUserModal } from './UserForm';

export default function UserTable({
  data,
  showCotisation,
  devenirMembre
}: {
  data: UserInfos[];
  showCotisation?: boolean;
  devenirMembre?: boolean;
}) {
  const headCells: HeadCell<UserInfos>[] = [
    {
      id: 'avatar',
      label: 'Prénom & Nom',
      formatter: ({ avatar, firstName, lastName, matricule }) => {
        return (
          <UserFormatter
            avatar={avatar}
            matricule={matricule}
            name={`${firstName} ${lastName}`}
          />
        );
      }
    },
    {
      id: 'cardMember',
      label: 'Carte membre',
      formatter: (item) => {
        return <UpdateMemberCard item={item} />;
      }
    },
    {
      id: 'disabled',
      label: 'Bloqué?',
      formatter: (item) => (
        <SwitchButton
          updateFunction={(value) => toggleUserStatus(item.uid)}
          value={!!item.disabled}
        />
      )
    },
    {
      id: 'uid',
      label: 'Action',
      formatter: (item) => {
        return (
          <>
            <ShowUserButton item={item} />
            <UpdateButton<UserInfos> modal={UpdateUserModal} item={item} />
            <DeleteButton
              id={item.uid}
              deleteFunction={deleteUserFunction}
              error={'Une erreur est survenue'}
              success={'Suppression terminé avec succès'}
            />
          </>
        );
      }
    }
  ];

  if (showCotisation) {
    headCells.splice(headCells.length - 1, 0, {
      id: 'domicile',
      label: 'Cotisation',
      formatter: (item) => {
        return (
          <>
            <CotisationUserButton
              ok={item.cotOk}
              defaultType="cotisation"
              item={item}
            />
          </>
        );
      }
    });
    headCells.splice(headCells.length - 1, 0, {
      id: 'acceptedCgu',
      label: 'Barkélou',
      formatter: (item) => {
        return (
          <>
            <CotisationUserButton
              ok={item.barkelouOk}
              defaultType="autre"
              item={item}
            />
          </>
        );
      }
    });
  }
  if (devenirMembre) {
    headCells.splice(headCells.length - 1, 0, {
      id: 'devenirMembre',
      label: 'En attente?',
      formatter: (item) => {
        return (
          <>
            <Box>{item.devenirMembre ? `✅` : '❌'}</Box>
          </>
        );
      }
    });
  }

  return <Table headCells={headCells} data={data} />;
}

export function ShowUserButton({ item }: { item: UserInfos }) {
  const [show, setShow] = useState(false);
  return (
    <>
      {show && (
        <ShowUserModal show={show} onHide={() => setShow(false)} item={item} />
      )}
      <Tooltip title={'Voir'} arrow placement="top-start">
        <Button
          onClick={() => setShow(true)}
          variant="text"
          startIcon={<RemoveRedEye />}
        />
      </Tooltip>
    </>
  );
}

export function CotisationUserButton({
  item,
  defaultType,
  ok
}: {
  item: UserInfos;
  defaultType: Cotisation['type'];
  ok?: boolean;
}) {
  const [show, setShow] = useState(false);
  const label = defaultType === 'autre' ? 'Barkélou' : 'Cotisation';
  return (
    <>
      {show && (
        <AutoCotisationModal
          show={show}
          onHide={() => setShow(false)}
          item={item}
          defaultType={defaultType}
        />
      )}
      {!ok && (
        <Tooltip title={label} arrow placement="top-start">
          <Button onClick={() => setShow(true)} variant="contained">
            {label}
          </Button>
        </Tooltip>
      )}
      {ok && <Box>✅</Box>}
    </>
  );
}
